module.exports = __webpack_public_path__ + "img/아마존로고.a9686991.png";